module.exports = __webpack_public_path__ + "static/media/banner2.05425b79.jpg";